const state = {
    smsUid: ''
};

export default state;
